const STANDALONE_PREVIEW_PAGE_RE =
	/three_check\.html|preview_three\.html|preview\.html|gsplat\.html|zoom\.html|filter\.html|glb\.html/i;

export function isStandalonePreviewPage(
	pathname = typeof window === "undefined" ? "" : window.location.pathname
): boolean {
	return STANDALONE_PREVIEW_PAGE_RE.test(pathname || "");
}
